import { Checklist, Heading, Image } from '@frontendmentorio/design-system-v2';

export default function Why() {
  return (
    <div className="px-5">
      <div className="container-xl flex flex-col gap-6 py-6 tablet:gap-8 tablet:items-center tablet:py-8">
        <div className="flex flex-col gap-5 tablet:items-center tablet:text-center">
          <Heading
            className="leading-tight tablet:text-center"
            level="1"
            tagName="h2"
          >
            Why developers choose Pro
          </Heading>

          <p className="max-w-prose text-lg text-neutral-500">
            Everything you need to build industry-standard projects, showcase
            your skills, and accelerate your career growth.
          </p>
        </div>

        <div className="flex flex-col gap-6 tablet:max-w-prose desktop:flex-row-reverse desktop:gap-7 desktop:items-center desktop:max-w-none">
          <Image
            alt="AI analysis summary of a project, including a list of issues and strengths."
            className="desktop:w-1/2"
            height={870}
            loading="lazy"
            src="/static/images/pro-why-2.webp"
            width={873}
          />

          <div className="flex flex-col gap-6 desktop:w-1/2">
            <Heading level="4" tagName="h3">
              Receive expert-level feedback on every project
            </Heading>

            <Checklist>
              <Checklist.Item heading="Your personal code mentor">
                Our AI reports provide comprehensive feedback on HTML, CSS,
                JavaScript, and accessibility.
              </Checklist.Item>

              <Checklist.Item heading="3x more insights">
                Our AI-enhanced reports catch up to 3x more issues across
                accessibility, code quality, and structure than our standard
                reports.
              </Checklist.Item>

              <Checklist.Item heading="Level up faster">
                Each report explains how to fix issues, helping you understand
                the problem, improve your code, and make faster progress.
              </Checklist.Item>
            </Checklist>
          </div>
        </div>

        <div className="flex flex-col gap-6 tablet:max-w-prose desktop:flex-row desktop:gap-7 desktop:items-center desktop:max-w-none">
          <Image
            alt="Design mockups of several projects, including a dashboard, a landing page, and a web app."
            className="desktop:w-1/2"
            height={870}
            loading="lazy"
            src="/static/images/pro-why-1.webp"
            width={873}
          />

          <div className="flex flex-col gap-6 desktop:w-1/2">
            <Heading level="4" tagName="h3">
              Build a portfolio that gets you hired
            </Heading>

            <Checklist>
              <Checklist.Item heading="Work on real-world projects">
                Build job-ready skills with premium challenges that mirror real
                client work, from landing pages to full web apps.
              </Checklist.Item>

              <Checklist.Item heading="Build a standout portfolio">
                Create polished, portfolio-ready projects that impress
                recruiters and hiring managers.
              </Checklist.Item>

              <Checklist.Item heading="Gain interview confidence">
                Solve complex tasks and gain real experience you can discuss in
                interviews. Members say these projects help them get hired.
              </Checklist.Item>
            </Checklist>
          </div>
        </div>

        <div className="flex flex-col gap-6 tablet:max-w-prose desktop:flex-row-reverse desktop:gap-7 desktop:items-center desktop:max-w-none">
          <Image
            alt="Design mockup of project in mobile, tablet, and desktop layouts, with light/dark theme and type system"
            className="desktop:w-1/2"
            height={870}
            loading="lazy"
            src="/static/images/pro-why-3.webp"
            width={873}
          />

          <div className="flex flex-col gap-6 desktop:w-1/2">
            <Heading level="4" tagName="h3">
              Master the design-to-code workflow that the pros use
            </Heading>

            <Checklist>
              <Checklist.Item heading="Practice with industry-standard design files">
                Get design files for every challenge to practice converting
                professional mockups into code like the pros.
              </Checklist.Item>

              <Checklist.Item heading="Build accurate projects faster">
                Access exact specs, like colors, spacing, fonts, and more, to
                match designs perfectly and deliver polished results faster.
              </Checklist.Item>

              <Checklist.Item heading="Gain real-world experience">
                Work with professional design assets and tools to build confidence
                following specs, which is an essential skill for any developer.
              </Checklist.Item>
            </Checklist>
          </div>
        </div>
      </div>
    </div>
  );
}
